import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Grid,
} from '@material-ui/core'
import 'date-fns'
import FileBase from 'react-file-base64'
import { useDispatch } from 'react-redux'

import useStyles from './styles.js'
import { updateUser } from '../../actions/user.js'

const ProfileForm = ({ open, handleClose, username, user }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const userNow = JSON.parse(localStorage.getItem('profile'))
  const [userData, setUserData] = useState({
    avatar: '',
    name: '',
    bio: '',
  })

  useEffect(() => {
    if (user) setUserData(user)
  }, [user])

  const handleSubmit = async () => {
    if (user.username === userNow?.result?.username) {
      dispatch(
        updateUser(username, {
          ...userData,
          username: userNow?.result?.username,
        })
      )
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='form-dialog-title'
    >
      <DialogContent>
        <form
          noValidate
          autoComplete='off'
          className={`${classes.root} ${classes.form}`}
          onSubmit={handleSubmit}
        >
          <Grid item className={classes.title} xs={12}>
            <Typography variant='h6'>Editing Profile</Typography>
            <Typography variant='body2'>
              Please be patient, updating may take a few minutes
            </Typography>
          </Grid>

          <div className={classes.fileInput}>
            <Typography variant='body2'>Upload image file max 100Kb</Typography>
            <FileBase
              type='file'
              multiple={false}
              onDone={({ base64 }) =>
                setUserData({ ...userData, avatar: base64 })
              }
            />
          </div>
          <Grid item xs={12}>
            <TextField
              name='name'
              variant='outlined'
              label='Name'
              fullWidth
              value={userData.name}
              onChange={(e) =>
                setUserData({ ...userData, name: e.target.value })
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name='bio'
              variant='outlined'
              label='Bio'
              fullWidth
              value={userData.bio}
              onChange={(e) =>
                setUserData({ ...userData, bio: e.target.value })
              }
            />
          </Grid>
          <Button
            className={classes.buttonSubmit}
            variant='contained'
            color='primary'
            size='large'
            type='submit'
            fullWidth
            onClick={handleClose}
          >
            Submit
          </Button>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} style={{ color: '#2940d3' }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ProfileForm
